var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dataProvider, getEndpoint } from './dataProvider';
import config from '../config';
import { mapSelection } from '../redux/sagas/utils';
import { noticeError } from '../utils/noticeError';
import { ERRORS } from '../constants';
const createBody = (selectionIds, byoGetSelection) => ({
    selectionIds: [selectionIds],
    byo: true,
    byoGetSelection,
    channel: 'internet',
});
const createOptions = (selectionIds, byoGetSelection) => ({
    method: 'POST',
    body: JSON.stringify(createBody(selectionIds, byoGetSelection)),
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});
export const getCombinationIdCheckValue = (topic) => topic ? topic.split('/').slice(-1)[0] : '';
export const checkPriceSubscription = (priceSubscription) => {
    if (!priceSubscription) {
        return {};
    }
    return Object.assign(Object.assign({}, priceSubscription), { topic: priceSubscription.state === 'CREATED'
            ? priceSubscription.topic
            : undefined });
};
export const getBuildSlipPrice = (selectionIds) => __awaiter(void 0, void 0, void 0, function* () {
    const path = `${config.betslipServiceEndpoint}/betslip/api/bets/buildSlip`;
    const endpoint = getEndpoint(path);
    const request = createOptions(selectionIds, false);
    const response = yield dataProvider(endpoint, request);
    if (!response.selections || response.selections.length < 1) {
        return null;
    }
    const selection = response.selections[0];
    if (!selection.prices || selection.prices.length < 1) {
        return null;
    }
    return {
        selection: {
            price: selection.prices[0],
            byoMarketId: null,
        },
        priceSubscription: checkPriceSubscription(response.priceSubscription),
    };
});
export const getBYOFreedomPrice = (selections, eventId, sportId, lastTopic) => __awaiter(void 0, void 0, void 0, function* () {
    if (selections.length > 1) {
        const path = `${config.betslipServiceEndpoint}/betslip/api/bets/getByoPrice`;
        const endpoint = getEndpoint(path);
        const request = {
            method: 'POST',
            body: JSON.stringify({
                eventID: eventId,
                selections: selections.map(mapSelection),
                combinationIdCheckValue: getCombinationIdCheckValue(lastTopic),
            }),
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Sport-Id': sportId,
            },
        };
        const response = yield dataProvider(endpoint, request).catch((error) => {
            noticeError(error, { errorType: ERRORS.BYO_GET_BYO_PRICE_ERROR });
        });
        return !response.selection
            ? null
            : Object.assign(Object.assign({}, response), { priceSubscription: checkPriceSubscription(response.priceSubscription) });
    }
    return null;
});
export const getPrice = (selections, eventId, sportId, lastTopic) => {
    if (config.useBYOFreedom) {
        return getBYOFreedomPrice(selections, eventId, sportId, lastTopic);
    }
    return getBuildSlipPrice(selections.map((selection) => selection.id));
};
export const getBetId = (selectionIds) => __awaiter(void 0, void 0, void 0, function* () {
    const path = `${config.betslipServiceEndpoint}/betslip/api/bets/buildSlip`;
    const endpoint = getEndpoint(path);
    const request = createOptions(selectionIds, true);
    const response = yield dataProvider(endpoint, request);
    if (!response.selections || response.selections.length < 1) {
        return null;
    }
    if (!response.selections[0].byoSelection) {
        return null;
    }
    return response.selections[0];
});
